import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";

import Landing from "@/pages/Landing";
import Apply from "@/pages/Apply";
import Login from "@/pages/Login";
import PublicReferral from "@/pages/PublicReferral";
import AmbassadorLayout from "@/layouts/AmbassadorLayout";
import Dashboard from "@/pages/Dashboard";
import Friends from "@/pages/Friends";
import Rewards from "@/pages/Rewards";
import Academy from "@/pages/Academy";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminApplications from "@/pages/admin/AdminApplications";
import AdminAmbassadors from "@/pages/admin/AdminAmbassadors";
import AdminStaff from "@/pages/admin/AdminStaff";
import AdminReferrals from "@/pages/admin/AdminReferrals";
import AdminRewards from "@/pages/admin/AdminRewards";
import AdminContent from "@/pages/admin/AdminContent";
import StaffLayout from "@/pages/staff/StaffLayout";
import StaffAmbassadors from "@/pages/staff/StaffAmbassadors";
import StaffReferrals from "@/pages/staff/StaffReferrals";
import StaffRewards from "@/pages/staff/StaffRewards";
import "@/App.css";
import { initNativeShell } from "@/lib/native";

function Protected({ children, role }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-[#0d3b66]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/apply" element={<Apply />} />
      <Route path="/login" element={<Login />} />
      <Route path="/ref/:code" element={<PublicReferral />} />

      <Route path="/app" element={<Protected role="ambassador"><AmbassadorLayout /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="friends" element={<Friends />} />
        <Route path="rewards" element={<Rewards />} />
        <Route path="academy" element={<Academy />} />
      </Route>

      <Route path="/staff" element={<Protected role="staff"><StaffLayout /></Protected>}>
        <Route index element={<StaffAmbassadors />} />
        <Route path="ambassadors" element={<StaffAmbassadors />} />
        <Route path="referrals" element={<StaffReferrals />} />
        <Route path="rewards" element={<StaffRewards />} />
      </Route>

      <Route path="/admin" element={<Protected role="admin"><AdminLayout /></Protected>}>
        <Route index element={<AdminAnalytics />} />
        <Route path="applications" element={<AdminApplications />} />
        <Route path="ambassadors" element={<AdminAmbassadors />} />
        <Route path="staff" element={<AdminStaff />} />
        <Route path="referrals" element={<AdminReferrals />} />
        <Route path="rewards" element={<AdminRewards />} />
        <Route path="content" element={<AdminContent />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    document.title = "DentOrdu Smile Ambassador Programme";
    initNativeShell();
  }, []);
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
